import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigation, useRoute } from '@react-navigation/native';
import {
  EdgeInsets,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import { View, styled, SxProp } from 'dripsy';
import { useTranslation } from 'react-i18next';

import { ToastService } from '@services';
import { parseApiError } from '@utils';
import {
  MainNavigatorNavigationPropType,
  MainNavigatorRoutePropType,
  screens,
} from '@navigation';
import { useAsyncInit, useNavOptionsSet } from '@hooks';
import { User } from '@models/Viewer/UserModel';
import { LikesUserList } from '@components';

type RoutePropType = MainNavigatorRoutePropType<'Likes'>;

type NavigationPropType = MainNavigatorNavigationPropType<'Likes'>;

const Container = styled(View)(() => ({
  flex: 1,
  bg: '$background0',
  px: ['$6', '$0'],
}));
function contentContainerStyle(props: EdgeInsets): SxProp {
  return {
    flexGrow: 1,
    pb: props.bottom,
  };
}

export const LikesScreen = observer(() => {
  const route = useRoute<RoutePropType>();
  const list = route.params.list;
  const insets = useSafeAreaInsets();
  const { t } = useTranslation();
  const nav = useNavigation<NavigationPropType>();

  const navigateToUser = useCallback((item: User) => {
    nav.push(screens.UserProfile, {
      id: item.id,
    });
  }, []);

  useNavOptionsSet({ title: t('likes.title') });

  useAsyncInit(() => fetch());

  async function fetch() {
    try {
      await list.fetch.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  async function fetchMore() {
    try {
      await list.fetchMore.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  return (
    <Container>
      <LikesUserList
        list={list}
        refetch={fetch}
        fetchMore={fetchMore}
        onPress={navigateToUser}
        contentContainerStyle={contentContainerStyle(insets)}
      />
    </Container>
  );
});
